<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a href="/"
          class="logo logo-light">
          <span class="logo-lg">
            <h1 class="title">
              {{ 'topbar.title' | translate }}
              <span> {{ 'topbar.subTitle' | translate }}</span>
            </h1>
          </span>
        </a>
      </div>

      <button type="button"
        class="btn btn-sm px-3 font-size-16 header-item"
        id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>
    </div>

    <div class="d-flex">
      <div class="dropdown d-inline-block"
        ngbDropdown>
        <button type="button"
          class="trans-btn btn header-item font-size-14"
          id="page-header-user-dropdown"
          ngbDropdownToggle>
          <span class="ml-1">{{ countryName }}</span>
        </button>

        <div class="dropdown-menu dropdown-menu-right"
          style="min-width: fit-content"
          ngbDropdownMenu>
          <a href="javascript:void(0);"
            class="dropdown-item notify-item"
            *ngFor="let item of listLang; let i = index"
            (click)="setLanguage(item.lang, i)"
            [ngClass]="{ active: cookieValue === item.lang }">
            <span class="align-middle">{{ item.text }}</span>
          </a>
        </div>
      </div>

      <button class="btn header-item font-size-14"
        (click)="logout()">{{ 'topbar.logout' | translate }}</button>

      <div class="dropdown d-inline-block"
        #alarmDrop="ngbDropdown"
        ngbDropdown
        (openChange)="checkDropDown($event)">
        <button type="button"
          class="btn header-item noti-icon"
          id="page-header-notifications-dropdown"
          ngbDropdownToggle>
          <i class="bx bx-bell"
            [ngClass]="{'bx-tada': allList>0}"></i>
          <span class="badge badge-danger badge-pill"
            *ngIf="allList > 0">{{ allList ? allList : 0 }}</span>
        </button>

        <div class="dropdown-menu dropdown-menu-right p-0 pt-3 pl-3"
          aria-labelledby="page-header-notifications-dropdown"
          *ngIf="alarm$ | async as alarm"
          ngbDropdownMenu>
          <p class="mb-2 pb-1 font-size-18 font-weight-bold">알림</p>

          <div class="scroll"
            *ngFor="let list of alarm">
            <div class="d-flex justify-content-between item"
              (click)="goExchange(list)">
              <div class="d-flex">
                <p class="d-flex">
                  <span class="font-weight-medium">{{ list?.name }}</span>
                  {{ list?.text }}
                </p>
                <p class="badge-danger">N</p>
              </div>
              <p class="ml-3">{{ list?.dateCreated | date : 'yy.MM.dd' }}</p>
            </div>
          </div>
          <p *ngIf="!alarm.length"
            class="mb-2 pb-1 font-size-12">새로운 알림이 없습니다.</p>
        </div>
      </div>
    </div>
  </div>
</header>